import { MailboxType } from 'owa-client-ids';
import { getGroupRoutedRequestInit } from 'owa-group-common';
import { IsFeatureEnabled as IsGroupFeatureEnabled } from 'owa-group-feature-flags';
// Map<groupId, MailboxInfo>
var groupMailboxInfoMap = {};
export default function getGroupMailboxInfo(groupId) {
    var groupIdKey = groupId.toLocaleLowerCase();
    if (!groupMailboxInfoMap[groupIdKey]) {
        var groupMailboxInfo = {
            type: MailboxType.GroupMailbox,
            mailboxId: groupId,
            returnModernConversationItems: !IsGroupFeatureEnabled('grp-useInboxGCIForGroups'),
            requestOptions: getGroupRoutedRequestInit(groupId),
        };
        groupMailboxInfoMap[groupIdKey] = groupMailboxInfo;
    }
    return groupMailboxInfoMap[groupIdKey];
}
//# sourceMappingURL=getGroupMailboxInfo.js.map